module.exports = __webpack_public_path__ + "img/password-hide.2112b0f9.svg";